import React, { FC } from 'react'

import styles from './SectionHeader.module.scss'

interface SectionHeaderProps {
  title: string
  body?: string
  textAlign?: 'left' | 'center'
}

export const SectionHeader: FC<SectionHeaderProps> = ({ title, body, textAlign = 'left' }) => {
  const alignmentClass = textAlign === 'center' ? styles.Center : styles.Left

  return (
    <div className={`${styles.SectionHeader} ${alignmentClass}`}>
      <h5 className={styles.Title}>{title}</h5>
      {body && <p className={styles.Body}>{body}</p>}
    </div>
  )
}
